require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-15-ways-to-pay-for-your-education.json") })
        }
      }, "path---blog-15-ways-to-pay-for-your-education");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-15-ways-to-pay-for-your-education!./.cache/json/blog-15-ways-to-pay-for-your-education.json
// module id = 543
// module chunks = 231608221292675